window.o_global = window.o_global || {};
window.o_util = window.o_util || {};



/**
 * Cookie related helper functions in dedicated namespace.
 *
 * @return {Object} Public methods of o_util.cookie.
 */
o_util.cookie = (function() {
    "use strict";

    const SAMESITE_VALUES = ["None", "Lax", "Strict"];

    /**
     * Function to check if a cookie searched by name exists.
     *
     * @example o_util.cookie.exists("name");
     *
     * @param {String} name     Name of the cookie to search for.
     *
     * @return {Boolean} If Cookie exist with or without value, it will return true.
     */
    function exists(name) {
        var values = document.cookie.split(";"),
            reg = new RegExp("^( )*" + encodeURIComponent(name) + "$", "g");

        for (var i = 0; i < values.length; i++) {
            if (reg.test(values[i].split("=")[0])) {
                return true;
            }
        }

        return false;
    }

    /**
     * Function to set a cookie. "name" and "value" are mandatory arguments. If further options are
     * omitted, the cookie will be set at root path and will expire in 60 minutes.
     *
     * @example o_util.cookie.set("someCookie", "cookieValue", { "minutes": 60, path: "/cookiePath"});
     *
     * @param {String} name                 Name of the cookie.
     * @param {String} value                Value of the cookie.
     * @param {Object} [options]            Contains configuration properties for the cookie.
     * @param {Number} [options.minutes]    Time to expiry in minutes. Default: 60.
     * @param {Number} [options.days]       Time to expiry in days. No default.
     * @param {String} [options.path]       Path attribute of the cookie. Default: "/".
     * @param {String} [options.domain]     Domain attribute of the cookie that will be set.
     * @param {String} [options.samesite]   Set one of the SameSite attributes ("None", "Lax", "Strict")
     */
    function set(name, value, options) {
        var timeInMinutes = 60,
            date = new Date(),
            _options = options || {},
            _cookieString;

        if (_options.minutes) {
            timeInMinutes = _options.minutes;
        }

        if (_options.days) {
            if (!_options.minutes) {
                timeInMinutes = 0;
            }

            timeInMinutes += _options.days * 24 * 60;
        }

        date.setTime(date.getTime() + (timeInMinutes * 60 * 1000));

        _cookieString = encodeURIComponent(name) + "=" + encodeURIComponent(value);
        _cookieString += "; expires=" + date.toGMTString();
        _cookieString += "; path=" + (_options.path || "/");

        if (_options.domain) {
            _cookieString += "; domain=" + _options.domain;
        }

        if (_options.samesite && SAMESITE_VALUES.includes(_options.samesite)) {
            _cookieString += `; SameSite=${_options.samesite}`;

            if(_options.samesite === "None") {
                _cookieString += `; Secure`;
            }
        }

        document.cookie = _cookieString;

        // track every cookie set by o_util.cookie
        if (o_util.toggle.get("LHAS_2048_TRACK_COOKIES", false)) {
            if (!!window.AS && !!window.AS.RUM && !!window.AS.RUM.sendCustomRequest && typeof window.AS.RUM.sendCustomRequest === "function") {
                window.AS.RUM.sendCustomRequest("o_util.cookie.set()", {
                    "cookiePath": options && options.path ? options.path : "/",
                    "cookieExpires": date.toGMTString(),
                    "cookieDomain": options && options.domain ? options.domain : -1,
                    "cookieName": name,
                    "cookieValue": value,
                    "cookieSameSite": options && options.samesite ? options.samesite : -1
                });
            }
        }


    }

    /**
     * Function to retrieve the value of a single cookie.
     *
     * @example o_util.cookie.get("myCookie");
     *
     * @param {String} name     Name of the cookie.
     *
     * @return {String} Value of the cookie.
     */
    function get(name) {
        var parts = document.cookie.split(/;\s*/),
            len = parts.length;

        name += "=";
        for (var i = 0; i < len; i += 1) {
            if (parts[i].indexOf(name) !== -1) {
                return decodeURIComponent(parts[i].replace(name, ""));
            }
        }
    }

    /**
     * Remove a cookie by a given name by setting the expiry date to a date far back in time.
     *
     * @example o_util.cookie.remove("myCookie");
     *
     * @param {String} name     Name of the cookie that should be removed.
     * @param {Object} [options]            Contains configuration properties for the cookie.
     * @param {String} [options.path]       Cookie Path, default: "/".
     * @param {String} [options.domain]     Cookie Domain
     */
    function remove(name, options) {
        var _options = options || {},
            _optionsString = "";

        _optionsString += " path=" + (_options.path ? _options.path : "/") + ";";

        if (_options.domain) {
            _optionsString += " domain=" + _options.domain + ";";
        }

        document.cookie = encodeURIComponent(name) + "=;" + _optionsString + "expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }

    /**
     * Return public API.
     */
    return {
        "exists": exists,
        "set": set,
        "get": get,
        "remove": remove
    };
}());

// Namespace fallbacks.
o_global.helper = o_global.helper || {};
o_global.helper.cookieExist = o_util.cookie.exists;
o_global.helper.getCookie = o_util.cookie.get;
o_global.helper.getCookieValue = o_util.cookie.get;
o_global.helper.removeCookie = o_util.cookie.remove;
o_global.helper.setCookie = o_util.cookie.set;
